define('SuiteDynamics.HeelAssistItemSwap.Entrypoint',
	[
		'SuiteDynamics.HeelAssistItemSwap.CartHooks',
		'SuiteDynamics.HeelAssistItemSwap.NavigationGuard'
	],
	function (
		CartHooks,
		NavigationGuard
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			CartHooks.mountToApp(container);
			NavigationGuard.mountToApp(container);
		}
	};
});
